import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'grab-ui';
import I18n from 'i18n-js';

import css from './company-selector.less';

const { Item, SubMenu, ItemGroup } = Menu;

const CompanySelectorDesktop = props => {
  const { profiles, currentProfileName, currentGroupName } = props;

  return (
    <SubMenu
      key="companySelector"
      className={css.companySelectorDesktop}
      title={
        <div>
          <p>{currentProfileName}</p>
          <p>{currentGroupName}</p>
        </div>
      }
      {...props}
    >
      {profiles.map(p => (
        <ItemGroup key={p.id} title={I18n.t(p.name, { defaultValue: p.name })}>
          {p.groups &&
            p.groups.map(g => (
              <Item
                data-type="groupSelect"
                data-profile-id={p.id}
                data-group-id={g.id}
                key={g.id}
              >
                {I18n.t(g.name, { defaultValue: g.name })}
              </Item>
            ))}
        </ItemGroup>
      ))}
    </SubMenu>
  );
};

CompanySelectorDesktop.propTypes = {
  profiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentProfileName: PropTypes.string.isRequired,
  currentGroupName: PropTypes.string.isRequired,
};

export default CompanySelectorDesktop;
